import { autoinject, customElement } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';
import { TooltipCustomAttribute } from '../framework/html_behaviors/bs-tooltip';

@autoinject
@customElement('deviation-request-create-selector')
export class DeviationRequestCreateSelectorCustomElement {
  @bindable headerText: string;
  @bindable description: string;
  @bindable kind: string;
  @bindable items: DeviationRequestCreateSelectorItem[] = [];
  @bindable disabled: boolean;
  showOptions: false;
  protected deviationRequestCreateSelectorTooltip: TooltipCustomAttribute;

  triggerTooltip() {
    this.deviationRequestCreateSelectorTooltip.show();
  }
}

export interface DeviationRequestCreateSelectorItem {
  icon: string;
  name: string;
  onClick(): void;
  info: string;
}
